import React, { useState } from 'react';
import { DialogProviderContextModel, DialogProviderDialog } from '../models';

export const DialogProviderContext = React.createContext({} as DialogProviderContextModel)

export default function DialogProvider(props: { children: any }) {
    const [dialogs, setDialogs] = useState<DialogProviderDialog[]>([]);

    const pushDialog = (dialog: DialogProviderDialog) => {
        if (dialogs.find(d => d.id === dialog.id)) {
            console.warn(`A dialog with id ${dialog.id} has already been pushed.`);
        }
        setDialogs([...dialogs, dialog]);
    }

    const forceDismissDialog = (id: string) => {
        if (!dialogs.find(d => d.id === id)) {
            console.warn(`dialog with id ${id} does not exist in the dialog provider. Cannot dismiss it`);
        }
        setDialogs([...dialogs.filter(dialog => dialog.id !== id)]);
    }

    const isOpen = (id: string): boolean => {
        return !!dialogs.find(d => d.id === id);
    }

    const updateDialog = (dialog: DialogProviderDialog) => {
        if (dialogs.find(d => d.id === dialog.id)) {
            console.warn(`dialog with id ${dialog.id} does not exist in the dialog provider. Cannot update it`);
        }
        setDialogs([...dialogs.filter(d => d.id !== dialog.id), dialog]);
    }

    return (
        <DialogProviderContext.Provider value={{ pushDialog, forceDismissDialog, isOpen, updateDialog }}>
            {dialogs.map(dialog => {
                return (
                    <div key={dialog.id}>
                        {dialog.component}
                    </div>
                );
            })}
            {props.children}
        </DialogProviderContext.Provider>
    )
}